<template>
  <div>
    <!-- {{ scope.row.orderId }} -->
    <el-table
      :data="userTypeList"
      style="width: 100%"
      :render-header="renderHeader"
      height="calc(100vh - 353px)"
      @sort-change="handleSort"
      :row-class-name="tableRowClassName"
    >
      <el-table-column
        prop="name"
        label="用户名称"
        align="left"
        min-width="170"
      >
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column
        prop="userType"
        label="用户类型"
        align="left"
        min-width="170"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.userType === 'ALL'"> 全部用户类型 </span>
          <span v-if="scope.row.userType === 'CONF'"> 白名单用户类 </span>
          <span v-if="scope.row.userType === 'CONDITION'"> 条件用户类型 </span>
        </template>
      </el-table-column>

      <el-table-column
        prop="registerDay"
        label="注册时间(天)"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          {{ scope.row.registerDay > 0 ? '大于' : '小于' }}
          {{ Math.abs(scope.row.registerDay) }}
        </template>
      </el-table-column>

      <el-table-column
        prop="tradeNum"
        label="交易次数(次)"
        align="center"
        min-width="140"
      >
        <template slot-scope="scope">
          {{ scope.row.tradeNum > 0 ? '大于' : '小于' }}
          {{ Math.abs(scope.row.tradeNum) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="tradeAmount"
        label="交易量(USDT)"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          {{ scope.row.tradeAmount > 0 ? '大于' : '小于' }}
          {{ Math.abs(scope.row.tradeAmount) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="loginRangeDay"
        label="登录间隔(天)"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          {{ scope.row.loginRangeDay > 0 ? '大于' : '小于' }}
          {{ Math.abs(scope.row.loginRangeDay) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="whiteList"
        label="白名单"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          {{ scope.row.whiteList }}
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.active">正常</span>
          <span v-else>关闭</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="updatedTime"
        label="创建时间"
        align="right"
        min-width="160"
      >
        <template slot-scope="scope">
          {{ scope.row.updatedTime | moment }}
        </template>
      </el-table-column>

      <!-- <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="handleActive(scope.row)">{{
            scope.row.active ? '关闭' : '激活'
          }}</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <!-- <div class="pag">
      <pagination
        :size="pagination.size"
        :total="totalCount"
        :page="pagination.page"
        @pageChanged="pageChanged"
      ></pagination>
    </div> -->

    <UserDetailDialog :id="id" :type="type" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import Pagination from 'components/pagination'
import updateDialog from '../updatedialog'
import order from '@/assets/order.png'
import copyImg from '@/assets/copy.png'
import UserDetailDialog from 'components/userDetailDialog'
import { positionOrderList } from '@/common/publicApi'
import tip from '@/assets/partnerCenter/tip.png'
export default {
  name: 'ContactHistoryList',
  data() {
    return {
      updateForm: {},
      updateUserTypeDialogVisible: false,
      newUserType: '',
      selectedForUserType: {},
      centerDialogVisible: false,
      textarea2: '',
      order,
      tip,
      copyImg,
      type: '',
      id: '',
      cacheRow: {},
      orderList: [],
      orderVisible: false,
      orderPage: {
        page: 1,
        size: 10,
      },
      orderTotal: 0,
    }
  },
  components: {
    Pagination,
    UserDetailDialog,
    updateDialog,
  },
  methods: {
    ...mapActions('closingCommission', ['addRemark']),

    ...mapMutations('closingCommission', [
      'setUserinfoDetailDialogVisible',
      'setUserinfoDetail',
    ]),
    ...mapMutations('contractassets', ['setUserDetailInfoVisible']),
    ...mapMutations('userTypeManagement', ['setPagination', 'setOrderBy']),
    // getContactHistory() {
    //   this.getHistory()
    // },
    handleActive() {},
    renderHeader(h, { column, $index }) {
      // 新建一个 span
      let span = document.createElement('span')
      // 设置表头名称
      span.innerText = column.label
      // 临时插入 document
      document.body.appendChild(span)
      // 重点：获取 span 最小宽度，设置当前列，注意这里加了 20，字段较多时还是有挤压，且渲染后的 div 内左右 padding 都是 10，所以 +20 。（可能还有边距/边框等值，需要根据实际情况加上）
      column.minWidth = span.getBoundingClientRect().width + 20
      // 移除 document 中临时的 span
      document.body.removeChild(span)
      return h('span', column.label)
    },

    copy(data) {
      let url = data
      let oInput = document.createElement('input')
      oInput.value = url
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      console.log(oInput.value)
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message({
        message: '复制成功',
        type: 'success',
        center: true,
      })
      oInput.remove()
    },
    pageChanged(pagination) {
      this.setPagination(pagination)
      this.$emit('refresh', { ...pagination })
    },
    handleUpdate(row) {
      this.updateForm = row
      // this.setUserinfoDetail(row);
      // this.setUserinfoDetailDialogVisible(true);
      this.centerDialogVisible = true
      this.textarea2 = row.remarks
    },
    add() {
      this.addRemark({
        channelId: this.userInfo.channelId,
        userId: this.updateForm.id,
        remarks: this.textarea2,
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success('添加成功')
          ;(this.textarea2 = ''), (this.centerDialogVisible = false)
          this.$emit('refresh')
        }
      })
    },
    goDetail(row) {
      this.$router.push({ path: `/home/closingCommission/detail`, query: row })
    },

    showBox(row, type) {
      this.type = type
      this.id = type == 2 ? row.userId : row.channelUserId
      this.setUserDetailInfoVisible(true)
    },
    handleSort({ column, prop, order }) {
      this.setOrderBy(null)
      if (order) {
        const orderSort = order === 'descending' ? 'desc' : 'asc'
        this.setOrderBy(`${prop},${orderSort}`)
      }
      this.$emit('refresh')
    },
    getOrderList() {
      positionOrderList({
        positionId: this.cacheRow.id,
        ...this.orderPage,
      }).then((res) => {
        if (res.code == 0) {
          this.orderList = res.data.list
          this.orderTotal = res.data.totalCount
        }
      })
    },
    colseOrder() {
      this.cacheRow = {}
      this.orderPage = {
        page: 1,
        size: 10,
      }
      this.orderTotal = 0
      this.orderVisible = false
    },
    showOrder(row) {
      this.cacheRow = row
      this.orderVisible = true
      this.getOrderList()
    },
    orderPageChanged(pagination) {
      this.orderPage = pagination
      this.getOrderList()
    },
    transform(str) {
      if (str) {
        return str.split('_')[0].toUpperCase()
      }
      return ''
    },
    tableRowClassName({ row }) {
      if (row.mark == true) {
        return 'redRow'
      }
      return ''
    },
  },
  computed: {
    ...mapState('management', ['userTypeList']),
    ...mapState(['userInfo']),
    ...mapState('userTypeManagement', [
      'pagination',
      'contactHistory',
      'totalCount',
      'orderBy',
    ]),
  },
}
</script>

<style lang="less" src="../../../../../styles/table.less" scoped></style>
<style lang="less" scoped>
.green {
  color: skyblue;
}
.red {
  color: #f54a45;
}
</style>
